import momenttimezone from "moment-timezone";

export const convertTime = (timestamp) => {
  const newsubmitdate = momenttimezone.unix(timestamp);
  var tz = momenttimezone.tz.guess();
  const convertedDate = newsubmitdate.tz(tz);
  let convertdate = convertedDate.format(
    process.env.REACT_APP_DATE_TIME_FORMAT
  );
  return convertdate;
};
